import React from "react";

const MainBanner = () => {
  return (
    <div
      className="
        h-full 
        md:h-[180px] 
        w-full 
        bg-[url('https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_main_bg_m.png')] 
        md:bg-[url('https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_main_bg_d.png')] 
        bg-cover 
        bg-no-repeat 
        bg-center
      "
    >
      <div className="flex flex-row items-center justify-between mx-4">
        <img
          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/vidhan_2025_m.png"
          className="w-[40%] md:hidden"
          alt="election-2025 banner"
        />
        <img
          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/vidhan_2025_d.png"
          className="w-[40%] hidden md:block"
          alt="election-2025 banner"
        />
        <img
          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/bihar_kiska.png"
          alt="election-2025 banner"
          className="w-[28%]"
        />
      </div>
    </div>
  );
};

export default MainBanner;
